import { render, staticRenderFns } from "./Dialog_GrantShop.vue?vue&type=template&id=28b34b18&scoped=true&"
import script from "./Dialog_GrantShop.vue?vue&type=script&lang=js&"
export * from "./Dialog_GrantShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b34b18",
  null
  
)

export default component.exports